import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { styles } from './Workbench.styles';
import ClaimDetailHeader from '../components/workbench/ClaimDetailHeader';
import EntityTabsContainer from '../components/workbench/EntityTabsContainer';
import { fetchWorkbenchData } from '../services/workbenchDataService';

const WorkbenchClaimDetails = () => {
  const { claimId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  
  const [workbenchData, setWorkbenchData] = useState(location.state?.workbenchData || null);
  const [associatedEntityData, setAssociatedEntityData] = useState(location.state?.associatedEntityData || {});
  const [activeTabKey, setActiveTabKey] = useState(location.state?.activeTabKey || 'CLAIM_DETAILS');
  const [entityCode, setEntityCode] = useState(location.state?.entityCode || 'CLAIM_DETAILS');
  const [manualTaskId, setManualTaskId] = useState(location.state?.manualTaskId || null);
  const [slaPercentage, setSlaPercentage] = useState(location.state?.slaPercentage ?? null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      // If associated entity data was passed from navigation, use it
      if (Object.keys(associatedEntityData).length > 0) {
        // console.log('Using associated entity data from navigation:', location.state);
        // console.log('Active tab:', activeTabKey);
        // Entity data is already available, no need to fetch
        return;
      }
      
    // Try to load from API first
      if (!workbenchData && manualTaskId) {
        try {
          setLoading(true);
          const data = await fetchWorkbenchData(manualTaskId);
          setWorkbenchData(data);
        } catch (error) {
          console.error('Error loading workbench data from API:', error);
          // Fall through to load reference data
        } finally {
          setLoading(false);
        }
      }
      
      // // If still no data, load from reference files
      // if (!workbenchData && Object.keys(associatedEntityData).length === 0) {
      //   try {
      //     setLoading(true);
      //     const claimDetailResponse = await fetch('/assets/ref/Documents/derived_entities/CLM-ID-0001/CLAIM_DETAILS.json');
      //     const claimDetailData = await claimDetailResponse.json();
          
      //     // Transform reference data to match workbench data structure
      //     const referenceData = {
      //       dataPoints: [
      //         {
      //           key: 'insuredName',
      //           label: 'Insured Name',
      //           component: 'subheader',
      //           format: 'username',
      //           businessKey: true,
      //           headerOrder: 0
      //         },
      //         {
      //           key: 'claimId',
      //           label: 'Claim ID',
      //           component: 'subheader',
      //           format: 'text',
      //           headerOrder: 1
      //         },
      //         {
      //           key: 'policyNumber',
      //           label: 'Policy',
      //           component: 'subheader',
      //           format: 'text',
      //           headerOrder: 2
      //         },
      //         {
      //           key: 'diagnosis',
      //           label: 'Diagnosis',
      //           component: 'subheader',
      //           format: 'text',
      //           headerOrder: 3
      //         },
      //         {
      //           key: 'claimedAmount',
      //           label: 'Claimed Amount',
      //           component: 'header',
      //           format: 'currency',
      //           showInHeader: true,
      //           headerOrder: 0
      //         },
      //         {
      //           key: 'approvedAmount',
      //           label: 'Approved Amount',
      //           component: 'header',
      //           format: 'currency',
      //           showInHeader: true,
      //           headerOrder: 1
      //         },
      //         {
      //           key: 'claimStatus',
      //           label: 'Status',
      //           component: 'header',
      //           format: 'text',
      //           showInHeader: true,
      //           headerOrder: 2
      //         }
      //       ],
      //       sessionState: {
      //         claimId: claimDetailData.claimId || claimId,
      //         insuredName: claimDetailData.insuredName,
      //         claimStatus: claimDetailData.claimStatus,
      //         diagnosis: claimDetailData.dischargeSummary?.diagnosis?.primaryDiagnosisText,
      //         claimedAmount: claimDetailData.claimedAmount,
      //         approvedAmount: claimDetailData.approvedAmount,
      //         eventDate: claimDetailData.eventDate,
      //         policyNumber: claimDetailData.policyNumber
      //       },
      //       claimDetail: claimDetailData
      //     };
          
      //     setWorkbenchData(referenceData);
      //   } catch (error) {
      //     console.error('Error loading reference data:', error);
      //   } finally {
      //     setLoading(false);
      //   }
      // }
    };
    
    loadData();
  }, [workbenchData, associatedEntityData, manualTaskId, claimId, activeTabKey]);
  // console.log('workbenchData', workbenchData, associatedEntityData);
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div>Loading claim details...</div>
      </div>
    );
  }

  if (!workbenchData) {
    return null;
  }

  const inDetailEntities =
    workbenchData.inDetailEntities ||
    workbenchData.in_detail_entities ||
    workbenchData.stepConfig?.in_detail_entities ||
    [];

  const associatedEntities =
    workbenchData.manualTask?.associated_entities || [];

  const detailEntities = inDetailEntities
    .map((item) => {
      const entityCd = item.entity_cd;
      if (!entityCd) return null;

      const match = associatedEntities.find(
        (entity) => entity.entity_cd === entityCd
      );
      if (!match) return null;

      const entityId = match.entity_id ?? match.id ?? match.entity_ref;
      if (!entityId) return null;

      return {
        entity_cd: entityCd,
        entity_id: entityId,
      };
    })
    .filter(Boolean);

  return (
    <div style={styles.container}>
      
      {/* Main Content Area */}
      <div style={styles.mainContent}>
        {/* Claim Detail Header */}
        {/* {console.log(workbenchData)} */}
        <ClaimDetailHeader
          dataPoints={workbenchData?.dataPoints}
          sessionState={workbenchData?.sessionState}
        />

        {/* Back Navigation */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          marginTop: '0.5rem',
          marginBottom: '0.5rem'
        }}>
          <button 
            onClick={() => navigate(-1)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.3rem',
              border: 'none',
              color: '#64748b',
              fontSize: '0.95rem',
              cursor: 'pointer',
              padding: '0.3rem 0.5rem',
              borderRadius: '4px',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f1f5f9'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <span style={{ fontSize: '1.2rem', display: 'inline-block', width: '25px', height: '25px', backgroundColor: '#64748b !important', color: '#64748b', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '0.5rem' }}>‹</span>
            <span style={{ fontWeight: '500' }}>Claim Details</span>
          </button>
          <span style={{ color: '#cbd5e1', margin: '0 0.3rem' }}>|</span>
          <span style={{ color: '#94a3b8', fontSize: '0.9rem' }}>
            Claim ID: {claimId}
          </span>
        </div>

        {/* Entity Tabs with Dynamic Forms */}
        <EntityTabsContainer 
          claimId={claimId} 
          associatedEntityData={associatedEntityData}
          initialActiveTab={activeTabKey}
        />
      </div>
    </div>
  );
};

export default WorkbenchClaimDetails;
